import { Church } from "./church.model";
import { Sectional } from "./sectional.model";

export class City {
    id?: number;
    name: string;
    code: string;
    sectional_id: number;
    churches: Church[];
    sectional: Sectional;

    constructor(name: string = null, code: string = null, sectional_id: number = null) {
        this.name = name;
        this.code = code;
        this.sectional_id = sectional_id;
        this.churches = [];
        this.sectional = {
            id: null,
            name: null,
            description: null,
            cities: [],
            district: {
                id: null,
                name: null,
                description: null,
                sectionals: []
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/models/City.model.ts